import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var render = function render() {
  var _setup$user, _setup$user2, _setup$user3;
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c(_setup.HeaderButton, {
    class: [_defineProperty({}, _vm.$style.LoyaltyButton, !_vm.isShowMobile), _vm.$style.button],
    attrs: {
      "href": "/loyalty-program"
    }
  }, [_setup.isDesktop || _vm.isShowMobile ? [(_setup$user = _setup.user) !== null && _setup$user !== void 0 && (_setup$user = _setup$user.loyalty) !== null && _setup$user !== void 0 && (_setup$user = _setup$user.levelIcon) !== null && _setup$user !== void 0 && _setup$user.aws ? _c(_setup.SImageLazy, {
    class: _vm.$style.customIcon,
    attrs: {
      "src": _setup.user.loyalty.levelIcon.aws,
      "alt": "",
      "object-fit": "contain",
      "eager": "",
      "fade": ""
    }
  }) : _c(_setup.SIcon, {
    attrs: {
      "icon": "i-crownOutline",
      "size": "24"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s((_setup$user2 = _setup.user) === null || _setup$user2 === void 0 || (_setup$user2 = _setup$user2.loyalty) === null || _setup$user2 === void 0 ? void 0 : _setup$user2.label))])] : _vm._e(), _vm._v(" "), (_setup$user3 = _setup.user) !== null && _setup$user3 !== void 0 && (_setup$user3 = _setup$user3.loyalty) !== null && _setup$user3 !== void 0 && _setup$user3.point ? _c('ScoreLabel', {
    class: _vm.$style.scoreLabel,
    attrs: {
      "value": _setup.user.loyalty.point,
      "size": "small"
    }
  }) : _vm._e()], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };